module.exports = __webpack_public_path__ + "img/locked.7a299131.svg";